// extracted by mini-css-extract-plugin
module.exports = {"main":"StarRating_main__uV8eU"};